export default function Divider() {
    return (
        <div className="flex items-center my-1">
            <hr className="w-full border-gray-300" />
            <span className="mx-2 text-gray-400">or</span>
            <hr className="w-full border-gray-300" />
        </div>
    )
}